import React from "react";
import { Box, Skeleton, List } from "@mui/material";
import styles from "./PointsEarnedSection.module.scss";

const PointsEarnedSectionSkeleton = () => {
  return (
    <Box className={styles.sectionWrapper}>
      {/* Header and Dropdown */}
      <Box className={styles.header}>
        <Skeleton variant="text" width={200} height={36} />
        <Skeleton
          variant="rectangular"
          width={180}
          height={40}
          sx={{ borderRadius: 2 }}
        />
      </Box>

      {/* Points Summary */}
      <Box mb={2} display={"flex"} justifyContent={"space-between"}>
        <Skeleton variant="text" width={160} height={24} />
        <Skeleton variant="text" width={160} height={24} />
      </Box>

      {/* Activity List */}
      <List disablePadding>
        {Array.from({ length: 5 }).map((_, index) => (
          <Box
            key={index}
            mb={2}
            display={"flex"}
            justifyContent={"space-between"}
          >
            <Box>
              <Skeleton variant="text" width={250} height={24} />
              <Skeleton variant="text" width={150} height={20} />
            </Box>
            <Skeleton variant="text" width={50} height={24} />
          </Box>
        ))}
      </List>

      {/* Show More */}
      <Box mt={2} display={"flex"} justifyContent={"center"}>
        <Skeleton variant="text" width={100} height={20} />
      </Box>
    </Box>
  );
};

export default PointsEarnedSectionSkeleton;
